export default __webpack_public_path__ + "static/media/Arrow3.09e1d8cb.svg";